"use client";

import { FilePreviewer } from "@/components/file-uploader/file-previewer";
import { useApiClient } from "@/hooks/use-api-client";
import { FileManagerProvider as FileProvider } from "@jace/file-uploader";
import { ReactNode } from "react";

export function FileManagerProvider({ children }: { children: ReactNode }) {
	const { client } = useApiClient();

	return (
		<FileProvider client={client} maxUploads={5}>
			{children}
			<FilePreviewer />
		</FileProvider>
	);
}
